import "../../libs/backbone/backbone.ajaxq.adapter.ts";
import GenericView from 'views/generic.view.ts';
import Handlebars from 'handlebars';
import Template from 'text-loader!../templates/queue.template.htm';
import RedirectionsTemplate from 'text-loader!../templates/queueRedirections.template.html';
import 'dhtmlxMessage';
import Model from '../models/queues.model.ts';
import OrganizationsOptions from "views/organizations_options.view.ts";
import VenuesOptions from "views/venues_options.view.ts";
import AgentsOptions from "views/agents_options.view.ts";
import CountersOptions from "views/counters_options.view.ts";
import ServiceTimePicker from "views/service_time_picker.view.ts";
import i18n  from 'l10n';
import croppie from '../../libs/croppie/js/croppie.js';


export default GenericView.extend({
    el: "#container",
    tagName: 'div',
	template: Handlebars.compile(Template),
	redirectionsTemplate: Handlebars.compile(RedirectionsTemplate),
	superInitialize: GenericView.prototype.initialize,
	model : null,
	id: null,
    editable: null,
    fields: null,
    userData: null,
    privilegeLevel: null,
    back: false,
    counterFlag: false,
    agentFlag: false,
    photoUrl: null,
	initialize: function (options) {
	    var self = this;
	    this.id = options ? options.id : null;
        this.userData = options.data;
        this.privilegeLevel = this.privilegeLevelToNumber(this.userData.privilegeLevel);

	    if(this.id)
        {
            this.editable = true;
            this.model = new Model({ id : this.id });
            this.model.fetch({
                success: function(response)
                {
                    self.render();
                },
                error: function(response, xhr, status)
                {

                }
            });
        }
        else
        {
            this.editable = false;
            this.model = new Model();
            this.render();
        }

        this.fields =
        {
            name: [this.isEmpty],
            englishName: [this.isEmpty],
            queue_macro: [this.isEmpty, this.minLengthNumber, this.noSpaces],
            ticket_number_max: [this.isEmpty, this.isNotNumeric],
            max_ticker_per_customer: [this.isNotNumeric],
            minimum_service_time: [this.isEmpty, this.isNotNumeric, this.isLessThan], //isLessThan than `notification_time_after_service`
            notification_time_after_service: [this.isEmpty, this.isNotNumeric]
        }
	},
	superRender: GenericView.prototype.render,
	render: function () {
		this.superRender();
		var self = this;

		var data = $.extend(this.model.toJSON(), { editable: this.editable });
		//make sure that when the queue is saved (after editing), the current image will remain intact and not be deleted
		this.photoUrl = data.imagePath;
		this.hasImage = data.imagePath != null;

        this.$el.html(this.template(data));

        this.initTools(data);
        this.serviceTimePicker = new ServiceTimePicker( { serviceTimes: data.serviceTimes } );


	},
	events: {
        "click #submitBack": "clickOnSubmitBack",
        "click #reset": "clickOnReset",
        "click #cancel": "goBack",
        "change #organizations select": "changeOrganizations",
        "change #venues select": "changeVenues",
        "change .to-validation input": "validateIt",
        "keyup .to-validation input": "validateIt",
        "focusout .to-validation input": "validateIt",
        "keypress  input[type=onlyNumbers]": "onlyNumbers",
        "keyup #description textarea": "validateDescription",
        "click #uploadPhoto": "upload_photo",
        "click #removePhoto": "remove_photo",
        "click #previewPhoto": "preview_photo",
	},
	existMacro: function(event) {

        var self = this;
        var element = $(event.target)
        var newMacro = element.val();
        $.ajaxq.abort("DefaultQueue");
        if((this.model.get("queueMacro") == null || this.model.get("queueMacro") == "") || ( this.model.get("queueMacro").toUpperCase() != newMacro.toUpperCase()))
        {


            element.parent().find("i").show();

            self.noUniqueMacro = false;

            $.ajaxDefaultQ({
                url: 'rest/api/queues/exists?acronym='+encodeURIComponent(newMacro),
                type: 'GET',
            }).done(function(response, status, xhr){
                element.parent().find("i").hide();
                if(response.data.value)
                {
                    self.noUniqueMacro = true;
                    self.setError(element.parent(), i18n.t("queue.NonUniqueMacro"));
                }
                 else
                    self.clearError(element.parent());
            })
            .fail(function(response) {
               element.parent().find("i").hide();
               console.info(response);
            });
        }
        else
        {
             this.clearError(element.parent());
        }

	},
	upload_photo: function(e) {
	    var self = this;
        $("input[name=file]").change(function () {
            if (this.files && this.files[0]) {
                var reader = new FileReader();
                reader.onload = function (e) {
                    self.photoUrl = e.target.result;
                    $('#queue_img').show();
                    $('#actionsP').show();
                    if(!self.croppie)
                        self.croppie = $('#queue_img').croppie({
                            url: self.photoUrl,
                            enableExif: true,
                            viewport: {
                                width: 256,
                                height: 256,
                                type: 'circle'
                            },
                            enforceBoundary: false //Restricts zoom so image cannot be smaller than viewport
                        });
                };

                reader.readAsDataURL(this.files[0]);

                $('#uploadPhoto').hide();
            }
        });
	},
	cropPhoto: function() {
	    return this.croppie ? this.croppie.croppie('result') : null;
	},
	preview_photo: function() {
	    var self = this;
	    if (this.croppie) {
	        this.croppie.croppie('result').then(function(imgSrc) {
                self.popup(imgSrc);
            });
	    }
	    else
	    {
	        this.popup("." + this.model.get("imagePath"));
	    }

	},
	popup: function(imgSrc) {
	    dhtmlx.alert({
            type: "alert",
            text: "<div style='background-color:#e1e1e1;' class='imageQueuePreview'><img style='float:inherit; margin:0 auto; padding:10px 0;' src='"+ imgSrc +"'/></div>"
        });
	},
	remove_photo: function()
	{
        $('#actionsP').hide();
        $('#uploadPhoto').show();
        this.photoUrl = null;

        $('#queue_img').croppie('destroy');
        $('#queue_img').html("");
        this.croppie = null;
	},
	clickOnReset: function(e)
    {
        $("#name").find("input").val("");
        $("#queue_macro").find("input").val("");
        $("#ticket_number_max").find("input").val("");
        $("#max_ticker_per_customer").find("input").val("");
        $("#description").find("textarea").val("");
    },
	validateDescription: function()
    {
	    this.characterLeft("#description");
    },
	clickOnSubmitBack: function(e)
    {
       var self = this;
       this.back = true;

       $.when(this.cropPhoto()).then(function(imgSrc) {
            if(!imgSrc && self.hasImage && self.photoUrl) {
                //console.error("Image remained the same");
                self.photoUrl = self.model.get("imagePath");
            }else if(imgSrc) {
                self.photoUrl = imgSrc;
                //console.error("Image changed");
            }else if(!imgSrc && !self.hasImage) {
                self.photoUrl = null;
                //console.error("no image at all");
            }else if(!imgSrc && self.hasImage && !self.photoUrl) {
                self.photoUrl = null;
                //console.error("image deleted");
            }else {
                //should never occur
                console.error("NONE OF THE ABOVE");
            }
           self.clickOnSubmit(null);
       });
    },
	clickOnSubmit: function(e)
    {
        var self = this;

        var has_error = this.validateFields(this.fields);
        has_error = this.validateDescription() || has_error;

        has_error = this.countersOptions.isTheDataWrong() || has_error;
        has_error = this.serviceTimePicker.hasError() || has_error;
        has_error = this.venuesOptions.isTheDataWrong() || has_error;
        has_error = this.organizationsOptions.isTheDataWrong() || has_error;
        has_error = this.noUniqueMacro || has_error;

        if(!has_error)
        {
            var tempModel = this.model.clone();

            this.model.set("name", $("#name").find("input").val());
            this.model.set("queueMacro", $("#queue_macro").find("input").val());
            this.model.set("maxTicketNum",$("#ticket_number_max").find("input").val());
            this.model.set("imagePath", this.photoUrl);
            this.model.set("minServiceTime", $("#minimum_service_time").find("input").val());
            this.model.set("notificationTimeAfterCalled", $("#notification_time_after_service").find("input").val());
            this.model.set("englishName", $("#englishName").find("input").val());

            if(this.model.get("id") != null) {
                var redirectValue = !isNaN( $("#redirects_picker").find(".queueRedirect").val() ) ? parseInt( $("#redirects_picker").find(".queueRedirect").val() ) : null
                var staticTextValue = $("#redirects_picker").find(".staticText").val().trim().length > 0 ? $("#redirects_picker").find(".staticText").val().trim() : null

                this.model.set("queueRedirect", redirectValue);
                this.model.set("staticText", staticTextValue);
            }

            var maxTicketPerCustomer = $("#max_ticker_per_customer input").val().trim();

            if( maxTicketPerCustomer == "" )
                 this.model.set("maxTicketsPerCustomer", 1);
            else
                 this.model.set("maxTicketsPerCustomer", maxTicketPerCustomer);

            this.model.set("serviceTimes", this.serviceTimePicker.getData( this.model.get("id") ));
            if ($("#description").find("textarea").val() != "")
                this.model.set("description", $("#description").find("textarea").val());
            else
                this.model.set("description", null);

            if(!this.editable)
            {
                this.model.set("venueId", this.venuesOptions.getData());
                this.model.set("orgId", this.organizationsOptions.getData());
            }

            this.model.set("status", this.intToStatus($("#queue_status select").val()));

            this.showActionProgressBar();

            var canItSaveAgents = !this.model.attributes.openNow || (this.model.attributes.openNow && !this.agentsOptions.areAgentsToBeDeleted());
            var canItSaveCounters = !this.model.attributes.openNow || (this.model.attributes.openNow && !this.countersOptions.areCountersToBeDeleted());


            if(!canItSaveAgents || !canItSaveCounters) {
                $.notify(i18n.t("queue.canNotRemoveAgentsCountersOnOpenQueue"));
                return;
            }

            $.when(window.ping()).then(function(resp) {
                $.ajaxSetup({
                    beforeSend: function (xhr) {
                        xhr.setRequestHeader('X-CSRF-TOKEN', window.csrf);
                    }
                });

                self.model.save(null, {
                    success: async function(model, response)
                    {

                        if(response.error && response.error.causes && response.error.causes[0].message == "QueueLimitReached") {
                            $("#submitBack").notify(
                                i18n.t("queue.queueLimitReached"),
                                { position:"top center", className: "error" }
                            );

                            return;
                        }

                        if(!self.editable)
                        {
                            self.agentsOptions.setNewQueueId(self.model.get("id"));
                            self.countersOptions.setNewQueueId(self.model.get("id"));
                        }

                        var countersSaved = function() {
                            var countersDeferred = $.Deferred();
                            self.countersOptions.updateData({
                                success: function() {
                                    countersDeferred.resolve(true);
                                },
                                fail: function() {
                                    countersDeferred.reject(false);
                                }
                            });
                            return countersDeferred.promise();
                        }

                        var agentsSaved =  function() {
                            var agentsDeferred = $.Deferred();
                            self.agentsOptions.updateData({
                                success: function() {
                                    agentsDeferred.resolve(true);
                                },
                                fail:  function() {
                                    agentsDeferred.reject(false);
                                }
                            });
                            return agentsDeferred.promise();
                        };

                        await window.ping();
                        var countersResp = await countersSaved();

                        await window.ping();
                        var agentsResp = await agentsSaved();

                        var type = self.editable ? i18n.t("queue.updated") : i18n.t("queue.added");

                        if(countersResp && agentsResp)
                            $.notify(i18n.t("queue.the_queue")+" " + type + " "+i18n.t("organization.successfully"), { position:"top center", className: "success" });
                        else if(countersResp && !agentsResp)
                            $.notify(i18n.t("queue.the_queue")+" " + type + " "+i18n.t("organization.successfully")  + ", "+ i18n.t("queue.couldNotSaveAgents"), { position:"top center", className: "success" });
                        else if(!countersResp && agentsResp)
                            $.notify(i18n.t("queue.the_queue")+" " + type + " "+i18n.t("organization.successfully")  + ", "+ i18n.t("queue.couldNotSaveCounters"), { position:"top center", className: "success" });
                        else {
                            $.notify(i18n.t("queue.the_queue")+" " + type + " "+i18n.t("organization.successfully")  + ", "+ i18n.t("queue.couldNotSaveCountersAndAgents"), { position:"top center", className: "success" });
                        }

                        setTimeout(self.goBack, 1000);



                        /*$.when(countersSaved(), agentsSaved()).then(function(countersResp, agentsResp) {
                            var type = self.editable ? i18n.t("queue.updated") : i18n.t("queue.added");

                            if(countersResp && agentsResp)
                                $.notify(i18n.t("queue.the_queue")+" " + type + " "+i18n.t("organization.successfully"), { position:"top center", className: "success" });
                            else if(countersResp && !agentsResp)
                                $.notify(i18n.t("queue.the_queue")+" " + type + " "+i18n.t("organization.successfully")  + ", "+ i18n.t("queue.couldNotSaveAgents"), { position:"top center", className: "success" });
                            else if(!countersResp && agentsResp)
                                $.notify(i18n.t("queue.the_queue")+" " + type + " "+i18n.t("organization.successfully")  + ", "+ i18n.t("queue.couldNotSaveCounters"), { position:"top center", className: "success" });
                            else {
                                $.notify(i18n.t("queue.the_queue")+" " + type + " "+i18n.t("organization.successfully")  + ", "+ i18n.t("queue.couldNotSaveCountersAndAgents"), { position:"top center", className: "success" });
                            }

                            setTimeout(self.goBack, 1000);
                        });*/

                        self.hideActionProgressBar();
                    },
                    error: function(model, response)
                    {
                        self.model = tempModel;
                        self.hideActionProgressBar();
                    }
                });
            });

        }
        else
        {
            $.notify(
                i18n.t("account.check_errors"),
                { position:"top center", className: "error" }
            );
        }
    },
    validateIt: function(event)
    {
        if(event.which > 36 && event.which < 41)
            return;

        var element = $(event.currentTarget).parent();
        var field = {};
        field[element.prop("id")] = this.fields[element.prop("id")]

        var has_error = this.validateFields( field );

        if(!has_error)
        {
            this.extendedValidations(event);
        }
    },
    extendedValidations: function(event)
    {
        switch(event.originalEvent.type)
        {
            case "keyup":
               switch(event.target.id)
               {
                    case "qacronym":
                        this.existMacro(event);
                    break;
               }
            break;
        }
    },
	changeOrganizations: function()
    {
        this.venuesOptions.load( {org: this.organizationsOptions.getData() } );
        this.clearError("#organizations");
    },
    changeVenues: function()
    {
        this.agentsOptions.load(this.venuesOptions.getData());
        this.clearError("#venues");
    },
    intToStatus: function(index)
    {
        switch(Number(index))
        {
            case 0:
                return i18n.t("queue.open");
            case 1:
                return i18n.t("queue.closed");
            case 2:
                return i18n.t("queue.suspended");
        }
    },
    initTools: function(data)
    {
        var params =
        {
            userPrivilege: this.privilegeLevel,
            editable: this.editable
        };

    	this.agentsOptions = new AgentsOptions($.extend(params, { id: this.model.attributes.id, queueStatus: this.model.attributes.status} ));
		this.organizationsOptions = new OrganizationsOptions($.extend(params, { orgId: data.orgId } ));
		this.venuesOptions = new VenuesOptions($.extend(params, { venueId: data.venueId } ));
		this.countersOptions = new CountersOptions( {queueId: data.id} );

		if(!this.editable)
        {
            this.organizationsOptions.load();
        }
        this.venuesOptions.load();

        var venueId = 0;
        if( data )
            venueId = data.venueId;
        else if(this.venuesOptions.getData())
            venueId = this.venuesOptions.getData();

        this.agentsOptions.load( venueId );

        this.loadRedirections(venueId);

    },
    loadRedirections: function(venueId) {
        var self = this;
        var $select = $("#redirects_picker").find(".queueRedirect");
        $select.empty();

        var params = "";
        if(this.model != null && this.model.get("id") != null && this.model.get("id") > 0) {
            params = 'queueId='+encodeURIComponent(this.model.get("id"))
        }

        var hasSelection = false;
        var queueRedirect = this.model.get("queueRedirect");
        if(queueRedirect != null && !isNaN(queueRedirect))
            hasSelection = true

        var redirectionsData = {
            "defaultOption": {
                "selected": !hasSelection ? 'selected="selected"' : ''
            },
            "options": [],
            "staticText": this.model.get("staticText")
        };

        $.ajaxDefaultQ({
            url: 'rest/api/venues/' + venueId + '/queues/getAllButCurrentForOrganization?' + params,
            type: 'GET',
        }).done(function(response, status, xhr){

            if(response.data != null && response.data.length > 0) {

                $.each(response.data, function(index, dataRow) {
                    var name = i18n.lng() == "el" ? dataRow.name : dataRow.englishName;

                    var option = {
                        "id": dataRow.id,
                        "selected": (hasSelection ? Handlebars.helpers.isSelectedOption(dataRow.id, queueRedirect) : ""),
                        "name": name,
                        "venueName": dataRow.venueName
                    };

                    redirectionsData.options.push(option);
                });

            self.$el.find("#redirects_picker").html(self.redirectionsTemplate(redirectionsData));

            }
            else {
                $select.append( $('<option selected="selected" disabled="disabled">' + i18n.t("queue.noQueues") +'</option>') )
            }
        })
        .fail(function(response) {
            $select.append( $('<option selected="selected" disabled="disabled">' + i18n.t("user.error") +'</option>') )
            console.info(response);
        });
    }
});

